import { LoadingOutlined } from '@ant-design/icons';
import { Button, Input, Popover, Upload } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { FC, useEffect, useState } from 'react';
import UpLoadImg from '../../assets/images/brands/grayUpArrow';
import DeleteBrand from '../../assets/images/brands/grayUpArrow copy';
import RemoveIcon from '../../assets/images/brands/removeIcon';
import { createImage } from '../../services/cataloge';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

interface IImageDetail {
  url: string;
}
interface IBrands {
  uid?: string;
  id?: string | number;
  name?: string;
  imageId?: number | string;
  image?: IImageDetail;
}
interface ICardBrand {
  item: IBrands;
  addName: (name: string) => void;
  addImgeId: (imageId: string | number) => void;
  index: number;
  deleteBrand: () => void;
}

const CardBrand: FC<ICardBrand> = ({ item, addName, addImgeId, index, deleteBrand }: ICardBrand) => {
  const [urlFile, setUrlFile] = useState<string | null>();
  const [imgId, setImgId] = useState<number | string | null>();
  const [nameFile, setNameFile] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [openPopover, setOpenPopover] = useState<boolean>(false);
  const [popoverImg, setPopoverImg] = useState<boolean>(false);
  const verifyFile = (file: File | any) => {
    const isJpgOrPng = file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJpgOrPng) {
      displayErrorNotification({ customJSXMessage: <>solo puedes subir archivos JPG/PNG!</> });
      return true;
    } else if (!isLt2M) {
      displayErrorNotification({ customJSXMessage: <>La imagen debe pesar menos de  2MB!</> });
      return true;
    }
    return false;
  };

  const chargeImg = async (file: string | Blob | RcFile) => {
    const incorrectCorrectFile = verifyFile(file);
    setLoading(true);
    if (!incorrectCorrectFile && file) {
      try {
        const dataImg = await createImage(file);
        setUrlFile(dataImg.data.medium);
        setImgId(dataImg.data.catalogImageId);
        setNameFile(dataImg?.data?.name);
        setLoading(false);
        addImgeId(dataImg.data.catalogImageId);
      } catch (error) {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };
  const removeInfoImg = () => {
    setImgId(null);
    setUrlFile(null);
    setNameFile(null);
  };

  const handleChangeData = (e: any) => {
    addName(e.target.value);
  };
  const defaultValues = () => {
    setImgId(item?.imageId || '');
    setNameFile(item?.name ? `${item.name}.PNG` : '');
    setUrlFile(item?.image?.url || '');
  };

  useEffect(() => {
    defaultValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="cardBrand">
      <Popover
        className="rounded-md"
        trigger="click"
        open={openPopover}
        color={'#333333'}
        style={{ borderRadius: '6px' }}
        placement="leftBottom"
        content={
          <div className="genericPopoverContent">
            <div className="textPopup">
              ¿Seguro quieres eliminar la marca?
              <br /> Si la eliminas todos los productos asociados se dejarán de visualizar en el e-commerce
            </div>
            <Button
              className="buttonPoup margin"
              onClick={() => {
                setOpenPopover(false);
              }}
            >
              No
            </Button>
            <Button
              className="buttonPoup"
              onClick={() => {
                deleteBrand();
                setOpenPopover(false);
              }}
            >
              Si
            </Button>
          </div>
        }
      >
        <div className="deleteIcon">
          <DeleteBrand
            onClick={() => {
              setOpenPopover(!openPopover);
            }}
          />
        </div>
      </Popover>
      <div className="boxCardBrand">
        <div className="brandNameContainer">
          <div className="title">Marca {index + 1}</div>
          <div>
            <div className="titleInput">Nombre de la marca</div>
            <Input
              className="inputStyle"
              onChange={e => {
                handleChangeData(e);
              }}
              value={item?.name}
              placeholder="Escribe el nombre de la marca"
            />
          </div>
        </div>
        <div className="loadFileContainer">
          {!!urlFile && !!nameFile && !!imgId ? (
            <>
              <Popover
                className="rounded-md"
                trigger="click"
                open={popoverImg}
                color={'#333333'}
                style={{ borderRadius: '6px' }}
                placement="top"
                content={
                  <div className="genericPopoverContent">
                    <div className="textPopup">¿Seguro quieres eliminar la imagen?</div>
                    <Button
                      className="buttonPoup margin"
                      onClick={() => {
                        setPopoverImg(false);
                      }}
                    >
                      No
                    </Button>
                    <Button
                      className="buttonPoup"
                      onClick={() => {
                        removeInfoImg();
                        setPopoverImg(false);
                      }}
                    >
                      Si
                    </Button>
                  </div>
                }
              >
                <span
                  onClick={() => {
                    setPopoverImg(true);
                  }}
                >
                  <div className="titleInput" style={{ color: 'transparent' }}>
                    Logo ( png. 60x18px)
                  </div>
                  <div className="loadUrl">
                    <div className="textContainer">{nameFile}</div>

                    <div className="containerX">
                      <RemoveIcon />
                    </div>
                  </div>
                </span>
              </Popover>
            </>
          ) : (
            <>
              <Upload
                showUploadList={false}
                customRequest={e => {
                  if (e.file) {
                    chargeImg(e.file);
                  }
                }}
              >
                <div className="titleInput">Logo ( png. 60x18px)</div>
                <div className="loadBox">
                  Cargar Logo
                  <div className="containerIcon">
                    {loading ? (
                      <LoadingOutlined className="uploadPosition" />
                    ) : (
                      <UpLoadImg className="uploadPosition" />
                    )}
                  </div>
                </div>
              </Upload>
            </>
          )}
        </div>
        <div className="firstImgContainer">
          <div className="titleInput">Previsualizacion en card</div>
          <div className="firstBox">
            <div className="specialText">Interna</div>
            <div className="containerFirstImg">
              {urlFile && <img alt="img-external" className="sizeImgBrands" src={urlFile} />}
            </div>
          </div>
        </div>
        <div className="secondImgContainer">
          <div className="titleInput" style={{ color: 'transparent' }}>
            Previsualizacion en card
          </div>
          <div className="secondBox">
            <div className="specialText">Externa</div>
            <div className="containerSecondmg">
              {urlFile && <img alt="img-internal" className="sizeImgBrands" src={urlFile} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardBrand;
